/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Yacht_TypeInputs */

const en_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yacht Type`)
};

const es_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de yate`)
};

const fr_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de yacht`)
};

const de_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yachttyp`)
};

const ja_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヨットの種類`)
};

const zh_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游艇类型`)
};

const ar_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع اليخت`)
};

const id_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Kapal Pesiar`)
};

const it_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Yacht`)
};

const ru_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип яхты`)
};

const pt_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Iate`)
};

const ko_field_yacht_type = /** @type {(inputs: Field_Yacht_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요트 유형`)
};

/**
* | output |
* | --- |
* | "Yacht Type" |
*
* @param {Field_Yacht_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_yacht_type = /** @type {((inputs?: Field_Yacht_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Yacht_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_yacht_type(inputs)
	if (locale === "es") return es_field_yacht_type(inputs)
	if (locale === "fr") return fr_field_yacht_type(inputs)
	if (locale === "de") return de_field_yacht_type(inputs)
	if (locale === "ja") return ja_field_yacht_type(inputs)
	if (locale === "zh") return zh_field_yacht_type(inputs)
	if (locale === "ar") return ar_field_yacht_type(inputs)
	if (locale === "id") return id_field_yacht_type(inputs)
	if (locale === "it") return it_field_yacht_type(inputs)
	if (locale === "ru") return ru_field_yacht_type(inputs)
	if (locale === "pt") return pt_field_yacht_type(inputs)
	return ko_field_yacht_type(inputs)
});